import { Button } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useCreateAccountModal } from '@features/chartOfAccounts/hooks/useCreateAccountModal'
import { Account } from '@modules-deprecated/app/accounts/types'

interface CreateAccountButtonProps {
  onSuccess?: (account: Account) => void
}

export const CreateAccountButton = ({ onSuccess }: CreateAccountButtonProps): ReactElement => {
  const { t } = useTranslation()
  const { openCreateAccountModal, createAccountModal } = useCreateAccountModal({ onSave: onSuccess })

  return (
    <>
      <Button variant="filled" onClick={openCreateAccountModal}>
        {t('coa.create_account')}
      </Button>
      {createAccountModal}
    </>
  )
}
